module.exports = __webpack_public_path__ + "static/img/aepic-22.0ccb9f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-22.jpg
// module id = +MpH
// module chunks = 52